import { addErrorNotification, NotificationType, removeNotification } from '@vista/omnichannel-components-domain';
import { SwapSeatsErrorCodeV1 } from '@vista-digital/ocapi-client';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
const id = getIdForComponentNotification('swap-seat-picker', NotificationType.Error, 'proceed');
export const getNotificationDetailsForError = (displayText, error) => {
    switch (error.errorCode) {
        case SwapSeatsErrorCodeV1.OrderIncludesPackageTickets:
            return {
                id,
                title: displayText.errorOrderIncludesPackageTicketsTitle,
                messages: [displayText.errorOrderIncludesPackageTicketsMessage]
            };
        case SwapSeatsErrorCodeV1.OrderIncludesInSeatDeliveryItems:
            return {
                id,
                title: displayText.errorOrderIncludesInSeatDeliveryItemsTitle,
                messages: [displayText.errorOrderIncludesInSeatDeliveryItemsMessage]
            };
        case SwapSeatsErrorCodeV1.ShowtimeEnded:
            return {
                id,
                title: displayText.errorShowtimeEndedTitle,
                messages: [displayText.errorShowtimeEndedMessage]
            };
        case SwapSeatsErrorCodeV1.SomeSeatsUnavailable:
            return {
                id,
                title: displayText.errorSelectedUnavailableSeatTitle,
                messages: [displayText.errorSelectedUnavailableSeatMessage]
            };
        default: {
            return {
                id,
                title: displayText.errorFailedToSwapSeatsTitle,
                messages: [displayText.errorFailedToSwapSeatsMessage]
            };
        }
    }
};
export const addProceedErrorNotification = (displayText, error) => {
    addErrorNotification(getNotificationDetailsForError(displayText, error), error);
};
export const removeProceedErrorNotification = () => removeNotification(id);
